export function initSiteFooter () {
  const yearEl = document.querySelector('.site-footer__year')
  if (yearEl) yearEl.textContent = String(new Date().getFullYear())
}
